// src/debuffImages.js
const debuffImages: Record<string, string> = {
    "Essence Flux Mark": "https://raw.communitydragon.org/14.9/game/assets/characters/ezreal/hud/icons2d/ezreal_w.png",
    "Sigil of Malice Mark": "https://raw.communitydragon.org/latest/game/assets/characters/leblanc/hud/icons2d/leblancq.png",
    "Ethereal Chains Tether": "https://raw.communitydragon.org/14.9/game/assets/characters/leblanc/hud/icons2d/leblance.png",
    "Mimic: Sigil of Malice Mark": "https://raw.communitydragon.org/latest/game/assets/characters/leblanc/hud/icons2d/leblancrq.png",
    "Mimic: Ethereal Chains Tether": "https://raw.communitydragon.org/14.9/game/assets/characters/leblanc/hud/icons2d/leblancre.png",
    "Explosive Charge": "https://raw.communitydragon.org/14.9/game/assets/characters/tristana/hud/icons2d/tristana_e.png",
};

export default debuffImages;
